/* LinksComponent.js */

"use strict";

const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./LinksRenderer");
const Registrations = require("../../../../../../../../../RegistrationNamespaces");
const deleteInstructionComponent = require("../../veils/deleteInstruction/DeleteInstructionComponent");

class LinksComponent extends DefaultColumnComponent {
    constructor(entity, context) {
        super(entity);
        this._entity = entity;
        this._context = context;
        this._gameEditor = context.gameEditor;
        this._activeOrgId = this._gameEditor._activeOrgId;
        this._odmOsPlatform = this.gameEditor._activeView._odmOsPlatform;
        this._OdmInstructionsEntity = this._gameEditor._activeView._OdmInstructionsEntity;

        this._isEditDisabled = false;
        this._isUploadDisabled = false;

        this._setDisabledStates();

        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._context = undefined;
        this._entity = undefined;
        this._isEditDisabled = undefined;
        this._isUploadDisabled = undefined;
        return prom;
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue() {}

    _setDisabledStates() {
        const contentType = this._entity.getContentType();

        switch (contentType) {
            case "BASE64_BINARY":
                this._isEditDisabled = true;
                this._isUploadDisabled = false;
                break;
            case "TEXT":
            case "BASE64_TEXT":
                this._isEditDisabled = false;
                this._isUploadDisabled = true;
                break;
            default:
                this._isEditDisabled = true;
                this._isUploadDisabled = true;
                break;
        }
    }

    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/

    manageInstruction() {
        this._gameEditor._activeView._isEditingInstruction = true;
        this._gameEditor._activeView._selectedInstructionForEdit = this._entity;
        this._gameEditor.runAction(Registrations.PLATFORM_EXPLORER_ACTION_ADD_INSTRUCTIONS);
    }

    deleteInstruction() {
        const platformName = this._odmOsPlatform.getName();
        const logger = this._gameEditor._logger;

        this._gameEditor._activeView._selectedLinkForDeleteInstruction = this._entity;
        return this.gameEditor._modalUserFeedback
            .hideDisplayed()
            .then(() => {
                return this.gameEditor._modalUserFeedback.displayCustom(
                    new deleteInstructionComponent(this._entity, platformName, logger),
                    {
                        dontHide: true,
                    }
                );
            })
            .then((result) => {
                if (result && result.confirmed) {
                    if (!result.checkboxValue) {
                        return this._odmOsPlatform.removeFromInstructionsRelationship(
                            this._entity.getId()
                        );
                    }
                    return this._removeAllRelationships();
                }
                return;
            })
            .catch((err) => {
                if (err && !err.userRejected) {
                    logger.warn(err, "LinksComponent.deleteInstruction() error");
                }
            })
            .finally(() => {
                if (this.gameEditor) {
                    this.gameEditor._modalUserFeedback.hideDisplayed();
                    if (!_.isEmpty(this._odmOsPlatform.getPendingRelationships())) {
                        return this._odmOsPlatform.updateRelationships();
                    }
                }
            });
    }

    _removeAllRelationships() {
        const logger = this._gameEditor._logger;
        const entityId = this._entity.getId();

        return this._OdmInstructionsEntity
            .loadRelated(
                this._activeOrgId,
                "OdmInstructions",
                entityId,
                "instructions",
                "OdmOsPlatform",
                true,
                {},
                {id: true},
                {name: 1},
                undefined
            )
            .then((platforms) => {
                // Early return if no platforms found
                if (!platforms || platforms.length === 0) {
                    logger.info("No platforms found to remove relationships from");
                    return [];
                }

                // Remove all relationships from the platforms
                const removalPromises = platforms.map((platform) =>
                    platform.removeFromInstructionsRelationship(entityId)
                );

                return Promise.all(removalPromises);
            })
            .then((platforms) => {
                // Filter out failed removals (null values)
                const validPlatforms = platforms.filter((platform) => platform !== null);

                if (validPlatforms.length === 0) {
                    logger.warn("No platforms to update after relationship removal");
                    return;
                }

                if (this.gameEditor) {
                    this.gameEditor._modalUserFeedback.hideDisplayed();
                }

                // Update all platforms asynchronously
                const updatePromises = validPlatforms.map((platform) =>
                    platform.update().catch((err) => {
                        logger.warn(err, `Failed to update platform ${platform.getId()}`);
                    })
                );

                return Promise.all(updatePromises);
            })
            .catch((err) => {
                logger.error(err, "LinksComponent._removeAllRelationships() error");
                // Ensure modal is hidden even on error
                if (this.gameEditor && this.gameEditor._modalUserFeedback) {
                    this.gameEditor._modalUserFeedback.hideDisplayed();
                }
                throw err; // Re-throw to propagate error
            });
    }
}

module.exports = LinksComponent;
